import _asyncToGenerator from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import { initMixpanel } from '@haogentech/mxp-util';
export default (/*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var store, currentEnvironment;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          store = _ref.store;
          currentEnvironment = process.env.APP_ENV || process.env.NODE_ENV;
          initMixpanel({
            project: 'portal',
            customConfig: {
              opt_out_tracking_by_default: false,
              opt_out_tracking_persistence_type: 'cookie',
              cookie_domain: '.moneyboat.co.uk'
            },
            tokens: {
              production: process.env.MIXPANEL_PROJECT_ID,
              staging: process.env.MIXPANEL_PROJECT_ID,
              development: process.env.MIXPANEL_PROJECT_ID,
              test: process.env.MIXPANEL_PROJECT_ID
            },
            environment: currentEnvironment
          });
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}());